var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpades(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7148 8.31561C19.8379 6.8333 17.981 5.0066 15.1958 2.88597C14.1084 2.05808 13.1071 1.36188 12.4584 0.923582C11.1987 0.0722657 11.162 0.0722656 11.0073 0.0722656C10.8529 0.0722656 10.8163 0.0722656 9.55708 0.919092C8.90802 1.35573 7.90569 2.0494 6.81756 2.87523C4.02894 4.99147 2.1668 6.82188 1.28317 8.31552C0.383732 9.8358 0 11.2409 0 13.014C0 17.5065 3.31126 19.5527 6.38785 19.5527C7.7374 19.5527 8.75379 19.2115 9.51383 18.7441L8.67247 21.9277H13.2939L12.4439 18.7114C13.208 19.1955 14.2384 19.5527 15.6165 19.5527C18.691 19.5527 22 17.5065 22 13.014C22 11.2435 21.6157 9.83844 20.7148 8.31561Z",
    fill: "#443C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpades);
export default __webpack_public_path__ + "static/media/spades.a31be7a0.svg";
export { ForwardRef as ReactComponent };